import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataServiceService } from '../helpers/data.service';
import { ConfigService } from '../helpers/config.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
    standalone: false
})
export class HomeComponent {
  csData:any = {};
  selected:any = {}
  openTabIndex:any = undefined;
  responsiveOptions = [
    {
      breakpoint: '800px',
      numVisible: 1,
      numScroll: 1
    }
  ];

  heroCoupons:any[] = [];
  desktopHeroCoupons:any[] = [];
  // If RTB stays disabled in production, remove '11' here and hide the RTB menu/route again.
  readonly heroCouponIds:string[] = ['31', '26', '1', '12', '5', '21', '11', '14'];
  readonly desktopHeroCouponIds:string[] = ['31', '26', '1', '12', '5', '21', '11', '14'];
  showCsData:boolean = true;
  constructor(private router: Router, public data:DataServiceService, public cs: ConfigService){
    this.data.setIsCouponLastStep(false);
    this.data.setHeaderMenuSelection('1');
  }

  async ngOnInit(): Promise<void> {
    this.csData = {};
    this.showCsData = true;
    await this.cs.getConfigurations('home', 'en');
    this.data.setCsObj(this.cs);
    this.csData = this.cs;
    this.buildHeroCouponLists();
    setTimeout(() => {
        this.showCsData = false;
    }, 100);
  }

  goToCoupon() {
    let obj = this.data.selectedCoupon;
    if (obj && obj.type) {
      if (obj.link) {
        this.router.navigate(['/' + obj.link]);
      } else {
        this.router.navigate(['/' + obj.type]);
      }
    }
  }

  buildHeroCouponLists() {
    this.heroCoupons = this.buildHeroCouponList(this.heroCouponIds);
    this.desktopHeroCoupons = this.buildHeroCouponList(this.desktopHeroCouponIds);
  }

  buildHeroCouponList(ids: string[]) {
    let list: any[] = [];
    for (const id of ids) {
      let coupon = this.getHeroCouponById(id);
      if (coupon) {
        list.push(coupon);
      }
    }
    return list;
  }

  getHeroCouponById(id: string) {
    if (this.data && this.data.mainCouponArr) {
      for (const item of this.data.mainCouponArr) {
        if (item && item.cuoponsArr) {
          let coupon = item.cuoponsArr.find((coupon: any) => coupon.id === id);
          if (coupon) {
            return {
              ...coupon,
              isPrimary: true
            };
          }
        }
      }
    }
    return undefined;
  }

  changeSelectedTabIndex(e:any) {
    if (e) {
      this.openTabIndex =e.index;
    }
  }

}
